import React, { createContext, useState, useContext } from 'react';
import Toast from '../components/ui/Toast';

const NotificationContext = createContext();

export const useNotification = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState({ message: '', type: 'info', action: null });

  const showNotification = (message, type = 'info', action = null) => {
    setNotification({ message, type, action });
  };

  const handleClose = () => {
    setNotification({ message: '', type: 'info', action: null });
  };

  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {children}
      {notification.message && (
        <Toast 
          message={notification.message} 
          type={notification.type} 
          action={notification.action}
          onClose={handleClose} 
        />
      )}
    </NotificationContext.Provider>
  );
};